<template>
    <div class="searchTable">
        <label for="search">搜尋</label>
        <select :value="type" @change="handleChange">
            <option v-for="option in options" :value="option" :key="option">{{ option }}</option>
        </select>
        <div class="search-type-wrapper">
            <input type="radio" value="keyword" v-model="searchType" />
            <input id="search" type="text" :value="keyword" @input="handleInput" placeholder="請輸入key的關鍵字" :disabled="searchType !== 'keyword'" />
            <input type="radio" value="empty" v-model="searchType" />
            <span>搜尋空值</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'SearchTable',
    data() {
        return {
            options: [],
            searchType: 'keyword',
        }
    },
    computed: {
        ...mapGetters(['langs', 'searchMethod', 'keyword', 'project', 'type'])
    },
    methods: {
        handleInput(e) {
            if (this.searchType === 'keyword') {
                this.$store.commit('setKeyword', e.target.value)
            }
        },
        handleChange(e) {
            this.$store.commit('setType', e.target.value)
        }
    },
    created() {
        this.options = ['key', ...this.langs, 'ticket']
    },
  watch: {
        searchType(val) {
            this.$store.commit('setSearchMethod', val)
        },
    }
}
</script>
<style lang="scss" scoped>
#search {
    padding: 5px;
    @media screen and (min-width: 768px) {
        padding: 2px;
    }
}
select {
    margin-left: .5rem;
    padding: 2px;
    @media screen and (min-width: 768px) {
        padding: 0px;
    }
}
.searchTable {
    display: flex;
    align-items: center;
    .search-type-wrapper {
        margin-left: 10px;
        input[type='radio'] {
            margin: 0 10px;
        }
    }
}
</style>
